import ApiResource from 'resources/ApiResource'

interface User {
  role: string;
  id: string | number;
  name: string;
  preferred_language?: string | null;
}

interface Course {
  id: string | number;
  title: string;
  category: string;
  organization: string;
  organization_id: string | number;
}

export default class TokenExchangeResource extends ApiResource {
  static urlRoot = '/onboarding/token_exchange' as const;

  readonly auth_token: string = '';
  readonly user: User = { role: '', id: '', name: '' };
  readonly courses: Course[] = [];

  pk() {
    return this.auth_token?.toString();
  }
} 
